import { PayloadAction } from "@reduxjs/toolkit";
import { put, all, takeLatest, call } from "redux-saga/effects";
import Budget from "models/Budget";
import Country from "models/Country";
import Duration from "models/Duration";
import StayType from "models/StayType";
import Transport from "models/Transport";
import budgetService from "services/budgetService";
import countryService from "services/countryService";
import durationService from "services/durationService";
import stayTypeService from "services/stayTypeService";
import transportService from "services/transportService";
import { LOAD_DATA, LOAD_DATA_SUCCESS } from "slices/global.slice";
import { SET_ERROR } from "slices/globalError.slice";

function* handleLoadData() {
  try {
    const budgets: Budget[] = yield call(budgetService.getAll);
    const transports: Transport[] = yield call(transportService.getAll);
    const stayTypes: StayType[] = yield call(stayTypeService.getAll);
    const durations: Duration[] = yield call(durationService.getAll);
    const countries: Country[] = yield call(countryService.getAllShortDisplay);
    yield put(
      LOAD_DATA_SUCCESS({
        budgets,
        transports,
        stayTypes,
        durations,
        countries,
      }),
    );
  } catch (ex: any) {
    put(SET_ERROR(ex));
  }
}

export default function* globalErrorSaga() {
  yield all([takeLatest(LOAD_DATA, handleLoadData)]);
}
